module.exports = __webpack_public_path__ + "img/player_damage_002.5c0a8dea.png";